import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router";

import {
  useAuth,
  useNoteCreation,
  useNoteUsage,
  usePreferences,
  useRecordingJobType,
} from "../../hooks";
import { useTeam } from "../../hooks/use-team";
import { alert } from "../common/Alert";
import Record from "../common/record/Record";

export function DashboardRecorder({ onIsRecordingChanged }) {
  const { setFirstTimeTourDisabled } = usePreferences();
  const [isRecording, setIsRecording] = useState(false);
  const { releaseWebEnableFtueTour } = useFlags();
  const { totalNotesCreated } = useNoteUsage();
  const { control, getValues, reset } = useForm();
  const { userUuid } = useAuth();
  const { currentTeam } = useTeam();
  const location = useLocation();
  const isPimsPal = location.pathname
    .toLowerCase()
    .includes("/pimspal/");

  const { selectedJobType } = useRecordingJobType();
  const createNote = useNoteCreation({ variant: "quick" });

  async function createNewNote(
    audioStorageLink,
    storageObjectName,
    jobTypeArg,
    isSyncedRecording = false,
    isNoteFromFileUpload = false,
    recordingAs = userUuid,
    titleArg = null,
    recordingConsentEventUuid = null,
  ) {
    const values = getValues();
    const jobType =
      jobTypeArg || selectedJobType?.value || "medical_record";
    const title = titleArg !== null ? titleArg : values.title;

    const result = await createNote({
      audioStorageLink,
      storageObjectName,
      jobType,
      title,
      recordingAs,
      teamUuid: currentTeam?.uuid,
      recordingConsentEventUuid,
    });

    if (!isSyncedRecording && !isNoteFromFileUpload) {
      alert("success", "Audio file uploaded!");
    }

    return result;
  }

  return (
    <>
      <div
        id="dashboardRecorder"
        className="border border-primary bg-primary rounded-xl shadow-xs flex flex-col relative flex-1 self-stretch"
      >
        <div className="flex flex-row justify-between w-full rounded-xl bg-secondary border-b border-secondary p-4 shadow-xs">
          <h3 className="text-primary">
            Create a Recording
            {releaseWebEnableFtueTour &&
              !isPimsPal &&
              totalNotesCreated !== undefined &&
              totalNotesCreated > 10 && (
                <span
                  onClick={() => {
                    setFirstTimeTourDisabled(false);
                  }}
                  title="Show Me How"
                >
                  <FontAwesomeIcon
                    className="inline-block cursor-help fill-current text-placeholder hover:text-brand ml-2"
                    icon={faQuestionCircle}
                    size="sm"
                  />
                </span>
              )}
          </h3>
        </div>

        <div className="p-4">
          <Record
            isRecording={isRecording}
            setIsRecording={(isRecording) => {
              setIsRecording(isRecording);
              onIsRecordingChanged?.(isRecording);
            }}
            control={control}
            getValues={getValues}
            createNewNote={createNewNote}
            shouldShowTitleInput={true}
            shouldUseSmallSize={true}
            reset={reset}
          />
        </div>
      </div>
    </>
  );
}
